export default __webpack_public_path__ + "static/chill-out-yoga-7218ef07888c92eb4d15317d61010795.jpg";